// Supported languages for the Double Rainbow Suites site switcher.
// `dir: "rtl"` triggers right-to-left layout (Hebrew).
export const LANGUAGES = [
  { code: "en", label: "English", native: "English", dir: "ltr" },
  { code: "es", label: "Spanish", native: "Español", dir: "ltr" },
  { code: "pt", label: "Portuguese (Brazil)", native: "Português", dir: "ltr" },
  { code: "fr", label: "French", native: "Français", dir: "ltr" },
  { code: "de", label: "German", native: "Deutsch", dir: "ltr" },
  { code: "nl", label: "Dutch", native: "Nederlands", dir: "ltr" },
  { code: "he", label: "Hebrew", native: "עברית", dir: "rtl" },
  { code: "zh", label: "Chinese", native: "中文", dir: "ltr" },
];

export const DEFAULT_LANG = "en";
export const STORAGE_KEY = "drs_lang";

export const langMeta = (code) =>
  LANGUAGES.find((l) => l.code === code) || LANGUAGES[0];
